export default function LoadingBeacon({ inline = false }) {
  const classes = inline ? "loader-icon inline" : "loader-icon";
  return (
    <div className={classes}>
      <div className="spinner--wv-star">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
    </div>
  );
}
